module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B09B37M5TS.916b6d64.jpg";